module.exports = __webpack_public_path__ + "img/rotate-right.014b94ba.svg";